import { Component, output, input } from '@angular/core';
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'Toggle',
  imports: [TranslatePipe],
  template: `
    <div
        class="
          rounded-full
          w-9
          h-[18px]
          flex
          items-center
          {{
          active()
            ? 'justify-end bg-blue-500 cursor-pointer'
            : 'bg-red-500 cursor-pointer'
        }}
        "
        [title]="(active() ? 'PAGE_DASHBOARD_LABEL_SWITCH_OFF' : 'PAGE_DASHBOARD_LABEL_SWITCH_ON') | translate"
        (click)="toggleStatus()"
    >
      <div class="w-[14px] h-[14px] bg-white rounded-full mx-0.5"></div>
    </div>
  `
})
export class Toggle {
  readonly active = input(true);
  toggled = output<void>();

  private working = false;

  toggleStatus() {
    // added a cooldown to prevent double clicks
    if (!this.working) {
      this.working = true;
      this.toggled.emit();
    }
    setTimeout(() => {
      this.working = false;
    }, 1000);
  }
}
